"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataAliasNestedController", {
    enumerable: true,
    get: function() {
        return DataAliasNestedController;
    }
});
const _common = require("@nestjs/common");
const _dataaliasnestedservice = require("~/services/data-alias-nested.service");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _dataapilimiterguard = require("~/guards/data-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let DataAliasNestedController = class DataAliasNestedController {
    // todo: handle case where the given column is not ltar
    async mmList(context, req, columnName, rowId, baseName, tableName) {
        return await this.dataAliasNestedService.mmList(context, {
            query: req.query,
            columnName: columnName,
            rowId: rowId,
            baseName: baseName,
            tableName: tableName
        });
    }
    async mmExcludedList(context, req, columnName, rowId, baseName, tableName) {
        return await this.dataAliasNestedService.mmExcludedList(context, {
            query: req.query,
            columnName: columnName,
            rowId: rowId,
            baseName: baseName,
            tableName: tableName
        });
    }
    async hmExcludedList(context, req, columnName, rowId, baseName, tableName) {
        return await this.dataAliasNestedService.hmExcludedList(context, {
            query: req.query,
            columnName: columnName,
            rowId: rowId,
            baseName: baseName,
            tableName: tableName
        });
    }
    async btExcludedList(context, req, columnName, rowId, baseName, tableName) {
        return await this.dataAliasNestedService.btExcludedList(context, {
            query: req.query,
            columnName: columnName,
            rowId: rowId,
            baseName: baseName,
            tableName: tableName
        });
    }
    async ooExcludedList(context, req, columnName, rowId, baseName, tableName) {
        return await this.dataAliasNestedService.ooExcludedList(context, {
            query: req.query,
            columnName: columnName,
            rowId: rowId,
            baseName: baseName,
            tableName: tableName
        });
    }
    // todo: handle case where the given column is not ltar
    async hmList(context, req, columnName, rowId, baseName, tableName) {
        return await this.dataAliasNestedService.hmList(context, {
            query: req.query,
            columnName: columnName,
            rowId: rowId,
            baseName: baseName,
            tableName: tableName
        });
    }
    async relationDataRemove(context, req, columnName, rowId, baseName, tableName, refRowId) {
        await this.dataAliasNestedService.relationDataRemove(context, {
            columnName: columnName,
            rowId: rowId,
            baseName: baseName,
            tableName: tableName,
            cookie: req,
            refRowId: refRowId
        });
        return {
            msg: 'The relation data has been deleted successfully'
        };
    }
    // todo: Give proper error message when reference row is already related and handle duplicate ref row id in hm
    async relationDataAdd(context, req, columnName, rowId, baseName, tableName, refRowId) {
        await this.dataAliasNestedService.relationDataAdd(context, {
            columnName: columnName,
            rowId: rowId,
            baseName: baseName,
            tableName: tableName,
            cookie: req,
            refRowId: refRowId
        });
        return {
            msg: 'The relation data has been created successfully'
        };
    }
    constructor(dataAliasNestedService){
        this.dataAliasNestedService = dataAliasNestedService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/mm/:columnName',
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/ln/:columnName'
    ]),
    (0, _extractidsmiddleware.Acl)('mmList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('columnName')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('baseName')),
    _ts_param(5, (0, _common.Param)('tableName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasNestedController.prototype, "mmList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/mm/:columnName/exclude',
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/ln/:columnName/exclude'
    ]),
    (0, _extractidsmiddleware.Acl)('mmExcludedList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('columnName')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('baseName')),
    _ts_param(5, (0, _common.Param)('tableName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasNestedController.prototype, "mmExcludedList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/hm/:columnName/exclude'
    ]),
    (0, _extractidsmiddleware.Acl)('hmExcludedList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('columnName')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('baseName')),
    _ts_param(5, (0, _common.Param)('tableName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasNestedController.prototype, "hmExcludedList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/bt/:columnName/exclude'
    ]),
    (0, _extractidsmiddleware.Acl)('btExcludedList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('columnName')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('baseName')),
    _ts_param(5, (0, _common.Param)('tableName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasNestedController.prototype, "btExcludedList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/oo/:columnName/exclude'
    ]),
    (0, _extractidsmiddleware.Acl)('ooExcludedList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('columnName')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('baseName')),
    _ts_param(5, (0, _common.Param)('tableName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasNestedController.prototype, "ooExcludedList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/hm/:columnName'
    ]),
    (0, _extractidsmiddleware.Acl)('hmList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('columnName')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('baseName')),
    _ts_param(5, (0, _common.Param)('tableName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasNestedController.prototype, "hmList", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/:relationType/:columnName/:refRowId'
    ]),
    (0, _extractidsmiddleware.Acl)('relationDataRemove'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('columnName')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('baseName')),
    _ts_param(5, (0, _common.Param)('tableName')),
    _ts_param(6, (0, _common.Param)('refRowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasNestedController.prototype, "relationDataRemove", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/data/:orgs/:baseName/:tableName/:rowId/:relationType/:columnName/:refRowId'
    ]),
    (0, _extractidsmiddleware.Acl)('relationDataAdd'),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('columnName')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('baseName')),
    _ts_param(5, (0, _common.Param)('tableName')),
    _ts_param(6, (0, _common.Param)('refRowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataAliasNestedController.prototype, "relationDataAdd", null);
DataAliasNestedController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_dataapilimiterguard.DataApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _dataaliasnestedservice.DataAliasNestedService === "undefined" ? Object : _dataaliasnestedservice.DataAliasNestedService
    ])
], DataAliasNestedController);
